import Cw8Show from "components/cw8/Cw8Show";
import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";

export const BibliotecaVirtualShow: React.FC<IResourceComponentsProps> = () => {
    const resourceName = "bibliotecaVirtual"
    return (
        <Cw8Show resourceName={resourceName} />
    );
};
